import { render, staticRenderFns } from "./GameCards.vue?vue&type=template&id=7b8b99d4&scoped=true&"
import script from "./GameCards.vue?vue&type=script&lang=js&"
export * from "./GameCards.vue?vue&type=script&lang=js&"
import style0 from "./GameCards.vue?vue&type=style&index=0&id=7b8b99d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b99d4",
  null
  
)

export default component.exports